import * as config from "config-api";
import { fetch } from "../../index";
import {
    mlDrivenItemsQuery,
    mlDrivenRelatedStoriesQuery,
    mlDrivenTrendingVideoContentItemsQuery,
    personalizedItemsQuery,
} from "../../queries/mlDrivenItems";
import {
    MLDRIVEN_ITEMS_TYPE_VIDEO,
    MLDRIVEN_ITEMS_ALGORITHM_TYPE,
    MLDRIVEN_ITEMS_TYPE,
} from "../../../../pages/FlexibleLandingPage/components/MLDrivenItemsWidget/constants";

const GRAPHQL_BASE_URL = config.getString("Client.contentApi.baseGraphqlURL");

export const getMLDrivenItems = (algorithm, args, pageSize, type) => {
    return fetch(
        GRAPHQL_BASE_URL,
        {
            query: mlDrivenItemsQuery(algorithm, args, pageSize, type),
        },
        false
    );
};

export const getPersonalizedItems = (
    algorithmId,
    userId,
    pageSize,
    contentId
) => {
    return fetch(
        GRAPHQL_BASE_URL,
        {
            query: personalizedItemsQuery(
                algorithmId,
                userId,
                pageSize,
                contentId
            ),
        },
        false
    );
};

export const getTrendingMLDrivenItems = (
    pageSize,
    type = MLDRIVEN_ITEMS_TYPE_VIDEO,
    trendingType = MLDRIVEN_ITEMS_TYPE.SHORT_FORM_VIDEO
) => {
    const algorithm = MLDRIVEN_ITEMS_ALGORITHM_TYPE.TRENDING;
    const args = {
        algorithmType: trendingType,
    };

    return getMLDrivenItems(algorithm, args, pageSize, type);
};

export const fetchMediaRelatedStories = (sourceId, pageSize = 5) => {
    const graphqlQuery = mlDrivenRelatedStoriesQuery();

    return fetch(
        GRAPHQL_BASE_URL,
        {
            query: graphqlQuery,
            variables: {
                sourceId,
                pageSize,
            },
        },
        false
    );
};

export const getTrendingVideoItems = (
    pageSize,
    trendingType = MLDRIVEN_ITEMS_TYPE.SHORT_FORM_VIDEO
) => {
    const graphqlQuery = mlDrivenTrendingVideoContentItemsQuery();
    const graphqlVariables = {
        pageSize: pageSize,
        trendingType: trendingType,
    };

    return fetch(
        GRAPHQL_BASE_URL,
        {
            query: graphqlQuery,
            variables: { ...graphqlVariables },
        },
        false
    );
};
